import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './centered-content.styl'

export default class CenteredContent extends Component {
  static propTypes = {
    children: PropTypes.any,
    marginAuto: PropTypes.bool,
    textAlign: PropTypes.bool,
    flex: PropTypes.bool,
    style: PropTypes.object,
  }

  static defaultProps = {
    marginAuto: false,
    textAlign: false,
    flex: false,
    style: {},
  }

  render() {
    const {
      marginAuto,
      textAlign,
      children,
      style,
      flex,
    } = this.props
    const classNames = []

    marginAuto && classNames.push(styles.marginAuto)
    textAlign && classNames.push(styles.textAlign)
    flex && classNames.push(styles.flex)

    return (
      <div className={classNames.join(' ')} style={style}>
        {children}
      </div>
    )
  }
}
